import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {Link} from 'react-router-dom';
import {ThemeContext} from '../../../common';

import {GAME_PHASE_PLAYING, GAME_PHASE_WAITING_FOR_PLAYERS} from '../../../../configs/constants';

const GamesRow = (props) => {
  const {
    id,
    name,
    state,
    leftTeam: {playersCount: leftCount},
    rightTeam: {playersCount: rightCount},
    playerLimit,
    onGameSelected,
  } = props;
  const players = leftCount + rightCount;
  const isGameFull = players === playerLimit;
  const gameLink = `/game/${id}`;

  const onGameSelect = (e) => {
    onGameSelected({id});
    e.preventDefault();
  };

  // eslint-disable-next-line no-nested-ternary
  const gameStateLabel = (state === GAME_PHASE_WAITING_FOR_PLAYERS) ? 'Waiting for Players' : (state === GAME_PHASE_PLAYING) ? 'Game in Progress' : 'Game Finished';

  return (
    <ThemeContext.Consumer>
      {(theme) => {
        const nameStyles = {
          color: theme.secondaryColor,
        };

        return (
          <li className="game-row">
            <Link to={gameLink} className="game-row__link" onClick={onGameSelect}>
              <div className="row row_space-between row_vcenter">
                <div className="cell">
                  <div className="game-row__name" style={nameStyles}>{name}</div>
                  <div className="game-row__creator">{gameStateLabel}</div>
                </div>
                <div className="cell">
                  <div
                    className={
                      classNames(
                        'game-row__players',
                        {
                          'game-row__players_full': isGameFull,
                        }
                      )
                    }
                  >{players}/{playerLimit}</div>
                </div>
              </div>
            </Link>
          </li>
        );
      }}
    </ThemeContext.Consumer>
  );
};

GamesRow.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  playerLimit: PropTypes.number.isRequired,
  onGameSelected: PropTypes.func.isRequired,
  leftTeam: PropTypes.shape({
    playersCount: PropTypes.number.isRequired,
  }).isRequired,
  rightTeam: PropTypes.shape({
    playersCount: PropTypes.number.isRequired,
  }).isRequired,
};

GamesRow.defaultProps = {
  title: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  players: PropTypes.number.isRequired,
  maxPlayers: PropTypes.number.isRequired,
  onGameSelected: PropTypes.func.isRequired,
};

export default GamesRow;
